import { render, staticRenderFns } from "./Pagination2.vue?vue&type=template&id=a9d4c004&"
import script from "./Pagination2.vue?vue&type=script&lang=js&"
export * from "./Pagination2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports